// src/services/articleService.ts
import { api } from "./api";
//import axios from "axios";
import { IArticle } from "../../types/article";
import { config } from "../../config/environment";

//const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const CLINIC_ID = config.clinic.id;

// Types for request payloads
export interface CreateArticlePayload
  extends Omit<IArticle, "clinicId" | "articleId" | "_id" | "slug"> {
  slug?: string;
}

export type UpdateArticlePayload = Partial<CreateArticlePayload>;

export const articleService = {
  getAllArticles: async () => {
    const response = await api.get<IArticle[]>(
      `/clinics/${CLINIC_ID}/articles`
    );
    return response.data;
  },

  getArticleBySlug: async (slug: string) => {
    const response = await api.get<IArticle>(
      `/clinics/${CLINIC_ID}/articles/${slug}`
    );
    return response.data;
  },

  getArticlesByCategory: async (category: IArticle["category"]) => {
    const response = await api.get<IArticle[]>(
      `/clinics/${CLINIC_ID}/articles/category/${category}`
    );
    return response.data;
  },

  createArticle: async (article: CreateArticlePayload) => {
    const response = await api.post<IArticle>(
      `/clinics/${CLINIC_ID}/articles`,
      article
    );
    return response.data;
  },

  updateArticle: async (articleId: string, article: UpdateArticlePayload) => {
    const response = await api.put<IArticle>(
      `/clinics/${CLINIC_ID}/articles/${articleId}`,
      article
    );
    return response.data;
  },

  deleteArticle: async (articleId: string) => {
    await api.delete(`/clinics/${CLINIC_ID}/articles/${articleId}`);
  },
};
